"use client";

// Storefront overlays that render on every page but show nothing until
// opened (or, for the promo and PWA banners, until they decide to show after
// mount). Their code — and the dialog/drawer primitives under it — is fetched
// once the page is idle, or at once if the overlay is opened first, instead of
// competing with the hero for the first second of bandwidth.

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import { usePageIdle } from "@/hooks/use-page-idle";
import { useCartDrawer } from "@/lib/cart/CartContext";

const CartDrawer = dynamic(() => import("./CartDrawer"), { ssr: false });
const PromoModal = dynamic(() => import("./PromoModal"), { ssr: false });
const InstallBanner = dynamic(() => import("./pwa/InstallBanner"), {
  ssr: false,
});
const PushBanner = dynamic(() => import("./pwa/PushBanner"), { ssr: false });

export function LazyCartDrawer() {
  const { isOpen } = useCartDrawer();
  // Mounted closed on idle so the first open still animates in.
  return usePageIdle() || isOpen ? <CartDrawer /> : null;
}

export function LazyPromoModal(props: ComponentProps<typeof PromoModal>) {
  return usePageIdle() ? <PromoModal {...props} /> : null;
}

export function LazyInstallBanner(props: ComponentProps<typeof InstallBanner>) {
  return usePageIdle() ? <InstallBanner {...props} /> : null;
}

export function LazyPushBanner() {
  return usePageIdle() ? <PushBanner /> : null;
}
